import { render, staticRenderFns } from "./CerrandoButacasModal.vue?vue&type=template&id=77fab9fa"
import script from "./CerrandoButacasModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CerrandoButacasModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports